import styled from "styled-components";

import { Textfield } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledContactsPerCompanyLimitTextField = styled(Textfield)`
    width: 76px;

    &.error {
        div:last-child {
            position: absolute;
        }
    }
`;

export const StyledContactsPerCompanyLimitRow = styled(Flex)<{ $inputError?: boolean }>`
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    position: relative;
    padding-bottom: ${({ $inputError }) => ($inputError ? "16px" : "0px")};
`;
